module.exports = __webpack_public_path__ + "static/media/solution-2-sec3.36a6030b.png";